import React from  "react";
import buildMiiImageGroupNew from '../../assets/images/buildMiiAssets/buildMiiImageGroupNew.svg'


const BuildMiiImageViewer = () => {

    return (
    <>
        <div className="flex flex-row h-full w-full justify-center ">
            <img className="flex h-[80%] w-[80%]" src={buildMiiImageGroupNew} alt="buildMiiWorkingWoman" />
        </div>
    </>
    )
}

export default BuildMiiImageViewer